import { UserSelectors } from '@next/core-lib/user';
import { createSelector, createFeatureSelector } from '@ngrx/store';

import { getCropYear } from 'src/app/store/selectors';

import { LegalStandardState } from '../models/legal-standard.model';

export const selectLegalStandardState = createFeatureSelector<LegalStandardState>('legalStandard');

export const selectFertilizationLegalStandards = createSelector(
  selectLegalStandardState,
  (state) => state.fertilizationLegalStandards,
);

export const selectMainCropFields = createSelector(
  selectFertilizationLegalStandards,
  (fertilizationLegalStandards) => fertilizationLegalStandards?.mainCropFields,
);

export const selectSubsequentCultivations = createSelector(
  selectFertilizationLegalStandards,
  (fertilizationLegalStandards) => fertilizationLegalStandards?.subsequentCultivations,
);

export const selectLegalStandardBalance = createSelector(
  selectFertilizationLegalStandards,
  (fertilizationLegalStandards) => fertilizationLegalStandards?.legalStandardBalance,
);

export const selectFertilizationLegalStandardsReportTitle = ({
  reportTitle,
}: {
  reportTitle: string;
}) =>
  createSelector(
    getCropYear,
    UserSelectors.selectCustomer,
    (cropYear, customer) => `${customer?.name ? customer.name : ''} ${reportTitle} ${cropYear}`,
  );
